import { Injectable } from '@angular/core';
import { DataLayerService } from '@features/tag-manager/data-layer.service';
import { EcommerceEvent } from '@features/tag-manager/ecommerce-event-enum';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { buildOrderCreation } from '../tag-manager/build-order-creation';
import { buildOrderPlacement } from '../tag-manager/build-order-placement';
import { CreateSuccessAction } from './actions/create-success-action';
import { DownloadAvailableAction } from './actions/download-available-action';
import { FormChangeAction } from './actions/form-change-action';
import { OrderActions } from './order-actions.enum';
import { OrderEvent } from './order-event.enum';

@Injectable()
export class OrderEffects {
  constructor(
    private actions$: Actions,
    private datalayerService: DataLayerService,
  ) {}

  @Effect({ dispatch: false })
  checkoutOption = this.actions$.pipe(
    ofType(OrderActions.FORM_CHANGE),
    tap(({ formValues }: FormChangeAction) => {
      const event = EcommerceEvent.CheckoutOption;
      this.datalayerService.push(event, buildOrderCreation(formValues));
    }),
  );

  @Effect({ dispatch: false })
  checkout = this.actions$.pipe(
    ofType(OrderActions.CREATE_SUCCESS),
    tap(({ order }: CreateSuccessAction) => {
      const event = EcommerceEvent.Checkout;
      this.datalayerService.push(event, buildOrderPlacement(order));
    }),
  );

  @Effect({ dispatch: false })
  downloadAvailable = this.actions$.pipe(
    ofType(OrderActions.DOWNLOAD_AVAILABLE),
    tap(({ order }: DownloadAvailableAction) => {
      if (order.completedAt && order.createdAt) {
        this.datalayerService.push(OrderEvent.downloadReady, {
          order_id: order.orderId,
          time:
            new Date(order.completedAt).getTime()
            - new Date(order.createdAt).getTime(),
        });
      }
    }),
  );
}
